import { memo } from 'react';
import { Button, Box } from '@mui/material';
import useIsMobileScreen from '../../utils/screenSizes/useIsMobileScreen';
import CenterScreen, { makeDataTestId as centerMakeDataTestId } from '../CenterScreen';

export const makeDataTestId = (dataTestId = 'error-screen') => {
  return {
    ...centerMakeDataTestId(dataTestId),
    prefix: dataTestId,
    button: `${dataTestId}.button`,
  };
};

export interface ErrorScreenProps {
  title?: string;
  text?: string;
  actionMessage: string;
  onActionClick?: () => void;
  dataTestId?: string;
  hideButton?: boolean;
}

const ErrorScreen: React.FC<ErrorScreenProps> = memo(
  ({ title, text, actionMessage, onActionClick, dataTestId, hideButton = false }: ErrorScreenProps) => {
    const { isMobile } = useIsMobileScreen().states;
    const allDataTestId = makeDataTestId(dataTestId);

    return (
      <CenterScreen title={title} text={text} dataTestId={allDataTestId.prefix}>
        <Box mt={3}>
          {hideButton ? null : (
            <Button
              variant="contained"
              color="primary"
              data-testid={allDataTestId.button}
              fullWidth={isMobile}
              onClick={onActionClick}
            >
              {actionMessage}
            </Button>
          )}
        </Box>
      </CenterScreen>
    );
  },
);
export default ErrorScreen;
